import DashboardOverview from "@/components/DashboardOverview";
import { DASHBOARD_PATH } from "@/constants/constant";
import DashboardLayout from "@/layouts/DashboardLayout";
import Layout from "@/layouts/Layout";
import ActiveCampaign from "@/pages/Dashboard/ActiveCampaign";
import AllCampaign from "@/pages/Dashboard/AllCampaign";
import CampaginList from "@/pages/Dashboard/CampaginList";
import ClaimHistory from "@/pages/Dashboard/ClaimHistory";
import CodeManagement from "@/pages/Dashboard/CodeManagement";
import IndividualCampaigns from "@/pages/Dashboard/IndividualCampaigns";
import MoreClaims from "@/pages/Dashboard/MoreClaims";
import PrivateCampaign from "@/pages/Dashboard/PrivateCampagin";
import ProfileSettings from "@/pages/Dashboard/ProfileSettings";
import RecommendedCampaign from "@/pages/Dashboard/RecommendedCampaign";
import { Refferal } from "@/pages/Dashboard/Refferal";
import { ViewLog } from "@/pages/Dashboard/ViewLog";
import Home from "@/pages/Home/Home";
import NotFoundPage from "@/pages/NotFound/NotFound";
import AuthenticatedRoute from "@/Routes/AuthenticatedRoute";
import GuestRoute from "@/Routes/GuestRoute";
import { createBrowserRouter } from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/ref/:id",
    element: <Layout />,
    children: [{ path: "", element: <Home /> }],
  },
  {
    element: <GuestRoute />,
    children: [
      {
        path: "/",
        element: <Layout />,
        children: [{ path: "", element: <Home /> }],
      },
    ],
  },
  {
    path: "/dashboard",
    element: <AuthenticatedRoute />, // protects all dashboard routes
    children: [
      {
        element: <DashboardLayout />,
        children: [
          { path: "", element: <DashboardOverview /> },
          { path: DASHBOARD_PATH.ALL_CAMPAIGNS, element: <AllCampaign /> },
          {
            path: DASHBOARD_PATH.ALL_Private_CAMPAIGNS,
            element: <PrivateCampaign />,
          },
          {
            path: DASHBOARD_PATH.ALL_List_CAMPAIGNS,
            element: <CampaginList />,
          },
          {
            path: `${DASHBOARD_PATH.ALL_List_Codes}/:id`,
            element: <CodeManagement />,
          },
          {
            path: `${DASHBOARD_PATH.INDIVIDUAL_CAMPAIGN}/:id`,
            element: <IndividualCampaigns />,
          },
          { path: DASHBOARD_PATH.CLAIM_HISTORY, element: <ClaimHistory /> },
          {
            path: DASHBOARD_PATH.PORFILE_SETTINGS,
            element: <ProfileSettings />,
          },
          {
            path: DASHBOARD_PATH.ACTIVE_CAMPAIGNS,
            element: <ActiveCampaign />,
          },
          {
            path: DASHBOARD_PATH.RECOMMENDED_CAMPAIGNS,
            element: <RecommendedCampaign />,
          },
          { path: DASHBOARD_PATH.MORE_CLAIMS, element: <MoreClaims /> },
          { path: DASHBOARD_PATH.VIEW_LOG, element: <ViewLog /> },
          { path: DASHBOARD_PATH.REFFERAL, element: <Refferal /> },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
]);

export default router;

// import DashboardOverview from "@/components/DashboardOverview";
// import { DASHBOARD_PATH } from "@/constants/constant";
// import DashboardLayout from "@/layouts/DashboardLayout";
// import Layout from "@/layouts/Layout";
// import ActiveCampaign from "@/pages/Dashboard/ActiveCampaign";
// import AllCampaign from "@/pages/Dashboard/AllCampaign";
// import ClaimHistory from "@/pages/Dashboard/ClaimHistory";
// import IndividualCampaigns from "@/pages/Dashboard/IndividualCampaigns";
// import MoreClaims from "@/pages/Dashboard/MoreClaims";
// import ProfileSettings from "@/pages/Dashboard/ProfileSettings";
// import RecommendedCampaign from "@/pages/Dashboard/RecommendedCampaign";
// import Home from "@/pages/Home/Home";
// import { createBrowserRouter } from "react-router-dom";

// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <Layout />,
//     children: [{ path: "", element: <Home /> }],
//   },
//   {
//     path: "/dashboard",
//     element: <DashboardLayout />,
//     children: [
//       { path: "", element: <DashboardOverview /> },
//       {
//         path: DASHBOARD_PATH.ALL_CAMPAIGNS,
//         element: <AllCampaign />,
//       },
//       {
//         path: `${DASHBOARD_PATH.INDIVIDUAL_CAMPAIGN}/:id`,
//         element: <IndividualCampaigns />,
//       },
//       {
//         path: DASHBOARD_PATH.CLAIM_HISTORY,
//         element: <ClaimHistory />,
//       },
//       {
//         path: DASHBOARD_PATH.PORFILE_SETTINGS,
//         element: <ProfileSettings />,
//       },
//       {
//         path: DASHBOARD_PATH.ACTIVE_CAMPAIGNS,
//         element: <ActiveCampaign />,
//       },
//       {
//         path: DASHBOARD_PATH.RECOMMENDED_CAMPAIGNS,
//         element: <RecommendedCampaign />,
//       },
//       {
//         path: DASHBOARD_PATH.MORE_CLAIMS,
//         element: <MoreClaims />,
//       },
//     ],
//   },
// ]);

// export default router;
